import { useEffect } from 'react';
import { LazyClaimSetPage, LazyMyClaimsPage, LazyProfilePage } from '@/routes/lazyRoutes';

type PreloadFn = () => Promise<unknown> | void;
type ScheduleConfiguration = { gapMs?: number; defer?: boolean };

const isSaveData = () => {
  return !!(navigator as any)?.connection?.saveData;
};

const isSlowNetwork = () => {
  const et = (navigator as any)?.connection?.effectiveType as string | undefined;
  return et ? /^(2g|slow-2g)$/.test(et) : false;
};

const idle = (runner: () => void) => {
  if ('requestIdleCallback' in window) return (window as any).requestIdleCallback(runner, { timeout: 2500 });
  return setTimeout(runner, 0);
};

export function schedulePreloads(queue: PreloadFn[], configuration?: ScheduleConfiguration) {
  const gap = configuration?.gapMs ?? 200;
  const defer = configuration?.defer ?? false;

  if (isSaveData() || isSlowNetwork()) return;

  const runQueue = async () => {
    for (const preload of queue) {
      try {
        await preload();
      } catch (error) {
        console.error(error);
      }
      await new Promise((resolve) => setTimeout(resolve, gap));
    }
  };

  if (defer) {
    idle(runQueue as any);
  } else {
    void runQueue();
  }
}

export const usePreloadPages = () => {
  useEffect(() => {
    schedulePreloads(
      [() => LazyMyClaimsPage.preload(), () => LazyClaimSetPage.preload(), () => LazyProfilePage.preload()],
      { gapMs: 150, defer: true },
    );
  }, []);
};
